/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetAllReleasesRequest} from '@cash-web/protos/squareup/cash/mosaic/resources/api/v2/release.pb'
import {GetAllReleasesResponse} from '@cash-web/protos/squareup/cash/mosaic/resources/api/v2/release.pb'


export const getAllReleases = (request: GetAllReleasesRequest, options?: CashRequestOptions) => post<GetAllReleasesRequest, GetAllReleasesResponse>("/2.0/cash/get-all-releases", request, {...options, rejectOnError: true })